module.exports = __webpack_public_path__ + "static/media/fondoB.dbf77aab.png";